// extracted by mini-css-extract-plugin
export var actions = "_1o-0";
export var actionsContainer = "_1o-7";
export var border = "_1o-1";
export var childFullHeight = "_1o-g";
export var collapse = "_1o-2";
export var content = "_1o-b";
export var contentChild = "_1o-f";
export var fullscreen = "_1o-d";
export var hasLeftRadius = "_1o-l";
export var headerContainer = "_1o-3";
export var headerRow = "_1o-5";
export var hidePadding = "_1o-c";
export var navCollapsedGap = "_1o-m";
export var noScrollX = "_1o-n";
export var noScrollY = "_1o-o";
export var noTopPadding = "_1o-j";
export var optOutTopPadding = "_1o-e";
export var pageMain = "_1o-k";
export var pageOuter = "_1o-h";
export var pagePadding = "_1o-8";
export var pageScroll = "_1o-9";
export var profile = "_1o-p";
export var profileContainer = "_1o-q";
export var profileImage = "_1o-r";
export var profileMain = "_1o-s";
export var profileSubtitle = "_1o-u";
export var profileTitle = "_1o-t";
export var settingsSurface = "_1o-a";
export var showLeftPadding = "_1o-i";
export var tabsPortalSlot = "_1o-6";
export var tabsWrapper = "_1o-4";
export var title = "_1o-v";